import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';

interface Props {
  color?: string;
}

export const Wrapper = styled.div`
  margin: auto auto auto 25px;
  display: none;
  align-items: center;
  &:before{
    content: '';
    height: 48px;
    border-left: 1px solid ${COLORS.GRAY};
    margin-right: 20px;
  }

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    display: flex;
  }
`;

export const Text = styled.h2`
  font-family: ${FONTS.ARISTOTELICA};
  font-size: 26px;
  color: ${(props: Props) => props.color };
  margin: 3px 0 0 8px;
  letter-spacing: 1px;
`;
